import React from 'react';

import {
  controlButton,
  controlButtons,
  controls,
} from '#Client/components/Controls/Controls.css';

type ControlsProps = {
  resetGrid: () => void;
  shuffleLetters: () => void;
};

export const Controls = ({resetGrid, shuffleLetters}: ControlsProps) => (
  <div className={controls}>
    <fieldset>
      <legend>Controls</legend>
      <div className={controlButtons}>
        <button className={controlButton} onClick={resetGrid}>
          Start Over
        </button>
        <button className={controlButton} onClick={shuffleLetters}>
          Shuffle
        </button>
      </div>
    </fieldset>
  </div>
);
